import { render, staticRenderFns } from "./warranty-tooltip.vue?vue&type=template&id=5a948347&scoped=true"
import script from "./warranty-tooltip.vue?vue&type=script&lang=js"
export * from "./warranty-tooltip.vue?vue&type=script&lang=js"
import style0 from "./warranty-tooltip.vue?vue&type=style&index=0&id=5a948347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a948347",
  null
  
)

export default component.exports